import { IGlobalActions, IInteractiveState } from '@bees-web/core/types'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { categoriesInteractive } from './categories/categories'

import { IHomeState } from '../interfaces'

import { guestSlider } from './banners/guestSlider'
import { signedSlider } from './banners/signedSlider'
import { homeInteractive } from './home/home'
import { policiesInteractive } from './policies/policies'
import { ratingsInteractive } from './ratings/ratings'
import { topDeals } from './topdeals/topDeals'

const useInteractive = (
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>,
  interactiveState: IInteractiveState<IHomeState>,
  globalActions: IGlobalActions
) => ({
  ...homeInteractive(dispatch, interactiveState, globalActions),
  ...guestSlider(dispatch, interactiveState, globalActions),
  ...signedSlider(dispatch, interactiveState, globalActions),
  ...ratingsInteractive(dispatch, interactiveState, globalActions),
  ...topDeals(dispatch, interactiveState, globalActions),
  ...categoriesInteractive(dispatch, interactiveState, globalActions),
  ...policiesInteractive(dispatch, interactiveState, globalActions),
})

export default useInteractive
